$(document).ready(function () {
  //Переключатель для добавления/удаления избранных товаров
  $(document).on('click', '[data-toggle-wishlist]', function(event) {
    event.preventDefault();
    const productId = $(this).data('product').includes('?') ? $(this).data('product').split('?')[0] : $(this).data('product');
    let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];

    if (productId && !wishlist.includes(productId)) {
      wishlist.push(productId);
    } else if (productId && wishlist.includes(productId)) {
      const index = wishlist.findIndex(item => item === productId);
      wishlist.splice(index, 1);
    }

    localStorage.setItem('wishlist', JSON.stringify(wishlist));

    toggleWishlistBtn(this);
    updateWislishCount();
  });
  //Обновить кнопку при добавлении/удалении избранного
  function toggleWishlistBtn(btn) {
    $(btn).toggleClass('_active');
  }

  //Обновить кнопки для выбранных товаров на странице
  function updateWislistBtns() {
    let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];

    wishlist.forEach(productId => {
      $(document).find(`[data-product="${productId}"]`).each((index, product) => {
        $(product).addClass('_active');
      });
    });
  }

  updateWislistBtns();
  //Получить товары из избранного на странице избранного
  function getProducts() {
    let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
    $("[data-wishlist-count]").html(wishlist.length);
    
    const requests = wishlist.map(productHandle => {
      $.getJSON(`${productHandle}.js`, function(product) {
        let moneyFormat = $('input[name="money_format"]').val();
        let from = moneyFormat.search('}}');
        const format = moneyFormat.substring(from + 2,moneyFormat.length);

        const priceTemplate = !product.compare_at_price ? 
          `
            <div class="product_card_prices">
              <div class="_price price__regular">
                <div class="exemptify_price">${formatPrice(product.price, Shopify.currency.active) } ${format}</div>
              </div>
            </div>
          `
          : 
          `
          <div class="product_card_prices price--on-sale">
              <div class="_price price_sale">
                <div class="_special">
                   <img class="_special_img" src="//www.meadowweb.com/cdn/shop/t/43/assets/sale_big.png?v=99836056013838181181716316050" />
                   <div class="exemptify_price _special_value">${formatPrice(product.price, Shopify.currency.active) } ${format}</div>
                </div>
                <div><strike class="exemptify_price">${formatPrice(product.compare_at_price, Shopify.currency.active) } ${format}</strike></div>
              </div>
            </div>
          `;
        const productTemplate = `
          <div class="product_card" data-product="${ product.url }">
            <button class="wishlist_remove" data-remove-wishlist>
              <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
                <path d="M1.73438 1C2.33209 7.56256 11.5586 14.6961 17.0045 17.414" stroke="#243E8F" stroke-width="2" stroke-linecap="round"/>
                <path d="M1.14267 18.0002C-0.504098 16.1217 12.6068 5.04499 14.6508 3.34485" stroke="#243E8F" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </button>
            <a href="${ product.url }" class="bg_img product_card_img">
              <img src="${ product.images[0] }" alt="${ product.title }">
            </a>
            <div class="product_card_content">
              <div class="product_card_content_top">
                <div class="product_card_brand">
                  <div>${ product.vendor }</div>
                </div>
                <a href="${ product.url }" class="product_card_title">${ product.title }</a>
              </div>
              <div class="product_card_content_bot">
                ${priceTemplate}
                <a href="${ product.url }" class="btn btn__green">to product</a>
              </div>
            </div>
          </div>
        `;
        $("[data-wishlist]").append(productTemplate);
      });
    });
  }

  function formatPrice(priceInCents, currencyCode) {
    const priceInDollars = priceInCents / 100;
    const currencyFormatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits: 2,
    });

    return currencyFormatter.format(priceInDollars);
  }
  
  if ($("[data-wishlist]").length > 0) {
    getProducts();
  }
  //Удалить избранный товар на странице с избранными товарами
  $(document).on('click', "[data-remove-wishlist]", function(event) {
    const productCart = $(this).closest('.product_card');

    const productId = productCart.data('product');
    let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];

    if (productId && wishlist.includes(productId)) {
      const index = wishlist.findIndex(item => item === productId);
      wishlist.splice(index, 1);
    }

    localStorage.setItem('wishlist', JSON.stringify(wishlist));

    productCart.remove();

    updateWislishCount();
    $("[data-wishlist-count]").html(wishlist.length);
  });
  
  //Получить количество товаров в избранном в шапке
  function updateWislishCount() {
    let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];

    if (wishlist.length < 1) {
      $('.header_wishlist .header_wishlist_counter').html(0);
      $('.header_wishlist .header_wishlist_counter').addClass('_hidden');
      return;
    };

    $('.header_wishlist .header_wishlist_counter').html(wishlist.length);
    $('.header_wishlist .header_wishlist_counter').removeClass('_hidden');
  }

  updateWislishCount();
});